import React, { useEffect } from "react";
import logoPicture from "common/assets/images/logo.png";
import { Htag } from "common/Htag/Htag";
import { ReactComponent as Logo } from "common/assets/icons/logo.svg";
import { serviceConfig } from "configs";

const MainPage: React.FC = (): JSX.Element => {
	return (
		<>
			<div className="grid pb-20 minPhone:pt-28 xl:pt-32 minPhone:px-4 xl:gap-24 xl:px-[241px] minPhone:gap-4 place-content-center place-items-center h-[90vh]">
				{serviceConfig.digidocs_template === 1 ? (
					<div className="grid gap-4 grid-cols-maxTwo place-items-center">
						<Logo className="" />
						<Htag tag="h1" type="semibold" className="text-3xl text-mainColor">
							Digidocs
						</Htag>
					</div>
				) : (
					<div className="grid grid-cols-1 gap-4 place-items-center place-content-center w-[60%]">
						<img src={logoPicture} alt="logo" className="w-32 h-32" />
						<Htag
							tag="h1"
							type="semibold"
							className="text-3xl text-center text-mainColor"
						>
							Türkmenistanyň Bilim ministrliginiň Innowasiýa Maglumat Merkezi
						</Htag>
					</div>
				)}
			</div>
		</>
	);
};

export default MainPage;
